export default __webpack_public_path__ + "static/media/typePlane.cee3abc4.cee3abc4.svg";